export enum ParameterName {
    JobStatus = 'Job Status'
}
